import { appendErrors, transformToNestObject } from 'react-hook-form';
/*
 * Original code : https://github.com/react-hook-form/resolvers
 * We just had to work with custom translation because we have our translation keys as error message
 *  */

const convertArrayToPathName = (paths) =>
  paths
    .reduce(
      (previous, path, index) =>
        `${previous}${typeof path === 'string' ? `${index > 0 ? '.' : ''}${path}` : `[${path}]`}`,
      ''
    )
    .toString();

const parseErrorSchema = (error, t, validateAllFieldCriteria) => {
  return Array.isArray(error.details)
    ? error.details.reduce((previous, { path, message = '', type, context }) => {
        const currentPath = convertArrayToPathName(path);

        return {
          ...previous,
          ...(path
            ? previous[currentPath] && validateAllFieldCriteria
              ? {
                  [currentPath]: appendErrors(
                    currentPath,
                    validateAllFieldCriteria,
                    previous,
                    type,
                    translateMessage(t, message, context)
                  )
                }
              : {
                  [currentPath]: previous[currentPath] || {
                    message: translateMessage(t, message, context),
                    type,
                    ...(validateAllFieldCriteria ? { types: { [type]: translateMessage(t, message, context) } } : {})
                  }
                }
            : {})
        };
      }, {})
    : [];
};

const translateMessage = (t, message, context) => {
  const { message: parsedMessage, context: parsedContext } = parseMessageWithContext(message, context);
  return t(parsedMessage, parsedContext);
};

const parseMessageWithContext = (joiMessage, originalContext) => {
  const [message, ...mappedContext] = (joiMessage ?? '').split('|||');
  const newContext = { ...originalContext };
  for (let i = 0; i < mappedContext.length; i++) {
    const [newContextKey, valueOrContextKey] = mappedContext[i].split(':', 2);
    newContext[newContextKey] = valueOrContextKey.startsWith('$')
      ? originalContext[valueOrContextKey.substr(1)]
      : valueOrContextKey;
  }

  return { message, context: newContext };
};

export const formHookJoiResolver = (schema, t, options = { abortEarly: false }) => async (
  values,
  _,
  validateAllFieldCriteria = false
) => {
  try {
    return {
      values: await schema.validateAsync(values, { ...options }),
      errors: {}
    };
  } catch (e) {
    return {
      values: {},
      errors: transformToNestObject(parseErrorSchema(e, t, validateAllFieldCriteria))
    };
  }
};

export const errorMessageWithContext = (message, contextMap) => {
  // translated by "parseMessageWithContext"
  const contextMapAsString = Object.entries(contextMap)
    .map(([i18nKey, joiKeyOrValue]) => `${i18nKey}:${joiKeyOrValue}`)
    .join('|||');
  return `${message}|||${contextMapAsString}`;
};
